import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadPmmCompleteGuide'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={
          'PMM PM PdM プロダクトマーケティングマネージャー プロジェクトマネージャー プロダクトマネージャー GAFAM Go-to-Market戦略 SaaS グロース戦略'
        }
        image={'https://aitria.co.jp/images/img/download/pmm-complete-guide/ogp.png'}
        url={'https://aitria.co.jp/download/pmm-complete-guide/'}
        title="PMMのすべて ーPdMと一体化したプロダクト成功の方程式ー | 資料ダウンロード | Aitria（アイトリア）"
        description="PMM（プロダクトマーケティングマネージャー）の導入から実践までを網羅した実務家向けガイドライン。PdMとの連携によるプロダクト成長、役割定義、組織設計、導入ステップを解説。"
      />
      <Template />
    </>
  )
}

export default Download
